var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"theme-table",attrs:{"id":"customers-page-overview-user-table","headers":_vm.headers,"items":_vm.lastOptInUsersTable,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.optin",fn:function(ref){
var item = ref.item;
return [_c('span',{directives:[{name:"show",rawName:"v-show",value:(item.optin),expression:"item.optin"}],staticClass:"text-success"},[_vm._v("Oui")]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!item.optin),expression:"!item.optin"}],staticClass:"text-danger"},[_vm._v("Non")])]}},{key:"item.segments",fn:function(ref){
var item = ref.item;
return _vm._l((item.segments),function(seg,sgeid){return _c('v-tooltip',{key:sgeid,attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({staticClass:"segment-item mr-2",class:{
						'segment-color-green' : seg.color === 'green',
						'segment-color-orange' : seg.color === 'orange',
						'segment-color-purple' : seg.color === 'purple',
						'segment-color-blue' : seg.color === 'blue',
						'segment-color-green-dark' : seg.color === 'green-dark',
						'segment-color-pink' : seg.color === 'pink'
					}},'span',attrs,false),on))]}}],null,true)},[_c('span',[_vm._v(_vm._s(seg.label))])])})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }